import { CommandService } from '@patsnap/tahiti-core';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';

export function useCommands() {
    const commands = injectService<CommandService>(CommandService);

    const executeCommand = commands.executeCommand.bind(commands);

    return {
        executeCommand,
        commands,
    };
}
